import {
    deleteTemplate,
    getTemplate,
    getTemplateFile,
    getTemplates,
    patchTemplate,
    postTemplate,
    postTemplateFile,
} from '@/api/template.api';
import type { ITemplate } from '@/domain/template/ITemplate';
import type { ITemplateDTO } from '@/domain/template/ITemplateDTO';
import type { ITemplateRepository, TTemplateFile, TTemplateSummary } from '@/application/ports/ITemplateRepository';

// HTTP adapter for ITemplateRepository. See @/api/template.api for the
// DTO mapping.
class HttpTemplateRepository implements ITemplateRepository {
    add(productName: string, dto: ITemplateDTO): Promise<ITemplate> {
        return postTemplate(productName, dto);
    }

    addFile(blob: Blob): Promise<TTemplateFile> {
        return postTemplateFile(blob);
    }

    get(productName: string, name: string): Promise<ITemplate> {
        return getTemplate(productName, name);
    }

    getAll(productName: string): Promise<TTemplateSummary[]> {
        return getTemplates(productName);
    }

    getFile(uuid: string): Promise<Blob> {
        return getTemplateFile(uuid);
    }

    remove(productName: string, name: string): Promise<void> {
        return deleteTemplate(productName, name);
    }

    update(productName: string, name: string, dto: Partial<ITemplateDTO>): Promise<ITemplate> {
        return patchTemplate(productName, name, dto);
    }
}

export { HttpTemplateRepository };
